import {
    SUB_JOB_PENDING_RECEIVE_YARN_REPORT_REQUEST,
    SUB_JOB_PENDING_RECEIVE_YARN_REPORT_SUCCESS,
    SUB_JOB_PENDING_RECEIVE_YARN_REPORT_FAILURE,
    SUB_JOB_PENDING_RECEIVE_YARN_FILTER_REPORT_REQUEST,
    SUB_JOB_PENDING_RECEIVE_YARN_FILTER_REPORT_SUCCESS,
    SUB_JOB_PENDING_RECEIVE_YARN_FILTER_REPORT_FAILURE
  } from "../types/sub-job-pending-receive-yarn-report-types";
  
  const initialState = {
    subJobPendingReceiveYarnReports: {},
    loading: false,
    error: null,
  };
  
  const subJobPendingReceiveYarnReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case SUB_JOB_PENDING_RECEIVE_YARN_REPORT_REQUEST, SUB_JOB_PENDING_RECEIVE_YARN_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case SUB_JOB_PENDING_RECEIVE_YARN_REPORT_SUCCESS: {
        return {
          ...state,
          subJobPendingStockReceiveYarnReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SUB_JOB_PENDING_RECEIVE_YARN_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          subJobPendingStockReceiveYarnFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SUB_JOB_PENDING_RECEIVE_YARN_REPORT_FAILURE, SUB_JOB_PENDING_RECEIVE_YARN_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default subJobPendingReceiveYarnReportReducer;
  